// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2XZJG","author":"Table_author__1TZO5","authorImage":"Table_authorImage__3yVhD","unreadRow":"Table_unreadRow__3ibTK"};